import React from "react";
import { formatNumber } from "../Utils/utils";
import { useSelector, useDispatch } from "react-redux";

import {
  updateDataForPdfVAS,
  updateBtnPdfVAS,
} from "../Store/secureInvestmentIncome/actions";
import { decryptEstandar } from "../Utils/CryptographyUtils";

const TableVAS = ({ items }) => {
  let nrDoc = items && items[0] ? decryptEstandar(items[0].typeDoc) === "2" ? "DNI :" : decryptEstandar(items[0].typeDoc) === "3" ? "PASAPORTE: " : "CARNET EXT." : "";
  let number = items && items[0] ? decryptEstandar(items[0].nroDoc) : "";
  const data = useSelector((state) => state.cotizador.valuesPdfVAS);
  const dispatch = useDispatch();
  const handleOnChange = (e) => {
    const { name } = e.target;
    const arrayName = name.split("_");
    const position = arrayName[1];
    const newData = data;

    newData[position].active = !newData[position].active;
    const activeBtn = newData.some((x) => x.active === true);

    dispatch(updateDataForPdfVAS(newData));
    dispatch(updateBtnPdfVAS(activeBtn));
  };

  return (
    <div className="md-g-wapper__container__table">
      <div className="title">COTIZACIONES</div>
      <div className="numdoc">
        {nrDoc} <span>{number}</span>
      </div>
      <div className="table-container">
        <table align="center" className="tablenew">
          <thead>
            <tr>
              <th
                data-field="name"
                className="md-g-wapper__container__table__item"
              >
                Moneda
              </th>
              <th
                data-field="id"
                className="md-g-wapper__container__table__item"
              >
                Prima
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                Tasa
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                Plazo
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                Cobertura por sobrevivencia
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                Cobertura por fallecimiento
              </th>
              <th
                data-field="price"
                className="md-g-wapper__container__table__item"
              >
                Cobertura adicional por fallecimiento accidental
              </th>
              <th
                data-field="checkbox"
                className="md-g-wapper__container__table__item"
              >
                Seleccione las simulaciones a descargar
              </th>
            </tr>
          </thead>
          <tbody>
            {items.length !== 0 &&
              Array.isArray(items) &&
              items.map(
                (
                  { money_vas, capital, toppings, tasa, years, active },
                  key
                ) => {
                  let validTopping = toppings[2].price === null ? 0 : toppings[2].price;

                  let cob_1 = toppings
                    ? formatNumber.new(parseFloat(toppings[0].price).toFixed(2))
                    : 0;
                  let cob_2 = toppings
                    ? formatNumber.new(parseFloat(toppings[1].price).toFixed(2))
                    : 0;
                  let cob_3 = toppings
                    ? formatNumber.new(
                        parseFloat(validTopping).toFixed(2)
                      )
                    : 0;
                  return (
                    <tr key={key}>
                      <td className="md-g-wapper__container__table__item">
                        {money_vas}
                      </td>
                      <td className="md-g-wapper__container__table__item">
                        {capital}
                      </td>
                      <td className="md-g-wapper__container__table__item">
                        {`${parseFloat(tasa).toFixed(2)}%`}
                      </td>
                      <td className="md-g-wapper__container__table__item">
                        {years}
                      </td>
                      <td className="md-g-wapper__container__table__item">
                        {cob_1}
                      </td>
                      <td className="md-g-wapper__container__table__item">
                        {cob_2}
                      </td>
                      <td className="md-g-wapper__container__table__item">
                        {cob_3}
                      </td>
                      <td className="md-g-wapper__container__table__item">
                        <label>
                          <input
                            name={`checkbox_${key}`}
                            className="filled-in"
                            type="checkbox"
                            defaultChecked={active}
                            onChange={(e) => handleOnChange(e)}
                          />
                          <span className="checkbox-name"></span>
                        </label>
                      </td>
                    </tr>
                  );
                }
              )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default TableVAS;
